<template>
    <div>
        <b-container class="px-0">
            <card-layout
                title=""
                class="mt-0"
                :display-card="false"
            >
              <apexchart height="120" type="donut" :options="chartOptions" :series="series"></apexchart>
            </card-layout>
        </b-container>
    </div>
</template>

<script setup>
    import { onMounted, ref} from 'vue';
    import CardLayout from '../details/CardLayout.vue'
    import styles from '../../../sass/_export.module.scss';

    const series = ref([213, 222]);

    const chartOptions = ref({
            chart: {
              type: 'donut',
              background: styles.white,
            },
            fill: {
              opacity: 0.85,
            },
            responsive: [{
              breakpoint: 480,
              options: {
                chart: {
                  width: 60
                },
                legend: {
                  position: 'bottom'
                }
              }
            }],
            plotOptions: {
              pie: {
                startAngle: -90,
                endAngle: 90,
                offsetY: 10,
                dataLabels: {
                  offset: 0,
                  minAngleToShowLabel: 5
                },
                donut: {
                  size: '0%',
                }
              },
            },
            dataLabels: {
              enabled: true,
              formatter: function(val, opts) {
                return opts.w.config.series[opts.seriesIndex];
              },
              style: {
                fontSize: '14px',
              },
            },
            states: {
              hover: {
                filter: {
                  type: 'darken'
                },
              }
            },
            // colors: ['#002D72', '#c0c0c0', '#580000'],
            colors: ['#002D72', '#580000'],
            labels: [
              'Current Dem',
              // 'Toss Up',
              'Current Rep',
            ],
            grid: {
              padding: {
                bottom: -75
              }
            },
            legend: {
              position: 'bottom',
            },
            tooltip: {
              style: {
                fontSize: '14px',
              },
            },
          });


    onMounted(() => {
        console.log('TotalsSafeRadial Component mounted.');
    });

</script>
<style>
</style>